import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Grid } from '@mui/material';
import { People as PeopleIcon, CheckCircle as CheckCircleIcon, Cancel as CancelIcon, CalendarMonth as CalendarIcon } from '@mui/icons-material';
import { getData } from "../../../../services/axiosInstance";
import { API_ENDPOINTS } from "../../../../services/endpoints";
import StatsCard from "../../../../components/common/StatsCard";

function PayInfo({ payPeriod }) {
    const [payrollInfo, setPayrollInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const getShortMonth = (fullMonth) => {
        return new Date(`${fullMonth} 1, 2020`).toLocaleString("en-US", {
            month: "short",
        });
    };

    useEffect(() => {
        const fetchPayrollInfo = async () => {
            if (!payPeriod) return;
            const [monthName, year] = payPeriod.split(" ");
            const shortMonth = getShortMonth(monthName);

            setLoading(true);
            try {
                const response = await getData(API_ENDPOINTS.getBatchPayrollSummary(year, shortMonth));
                if (response?.statusCode === 200) {
                    setPayrollInfo(response.result);
                }
            } catch (error) {
                setPayrollInfo(null);
            } finally {
                setLoading(false);
            }
        };
        fetchPayrollInfo();
    }, [payPeriod]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (!payrollInfo) {
        return <Typography sx={{ p: 2 }} color="textSecondary">No data found for this period.</Typography>;
    }



    return (
        <Box sx={{ p: 0.5 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" fontWeight="bold">
                    Payroll Overview
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Details for the billing cycle of {payPeriod}
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <StatsCard
                        title="Total Records"
                        value={payrollInfo.totalRecords}
                        icon={<PeopleIcon />}
                        color="#2196f3"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <StatsCard
                        title="Paid Employees"
                        value={payrollInfo.payedCount}
                        icon={<CheckCircleIcon />}
                        color="#4caf50"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <StatsCard
                        title="Unpaid Employees"
                        value={payrollInfo.notPayedCount}
                        icon={<CancelIcon />}
                        color="#f44336"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <StatsCard
                        title="Working Days"
                        value={payrollInfo.daysInMonth}
                        icon={<CalendarIcon />}
                        color="#ff9800"
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default PayInfo;